<div class="ms-modal-content">
  <ng-content *ngTemplateOutlet="contentTemplate"></ng-content>
</div>
<div class="w-full mb-2 flex justify-content-end ms-modal-footer">
  <div class="ms-modal-footer-content mt-3 mb-3">
    <ng-content *ngTemplateOutlet="footerTemplate"></ng-content>
  </div>
</div>
